<template>
  <b-overlay :show="showLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-for="item in pageData">

          <b-form-group
              :label="item.title"
              label-for="blog-content"
              class="mb-2"
          >
            <ckEditorMain ref="editorContent" @getEditorContent="setEditorContent"
                          :defaultContent="item.content"></ckEditorMain>
            <!--            <b-form-textarea-->
            <!--                id="blog-content"-->
            <!--                rows="4"-->
            <!--                v-model="item.content"-->
            <!--            ></b-form-textarea>-->
          </b-form-group>

          <!-- Action Buttons -->
          <b-button
              variant="primary"
              class="mt-1 mb-sm-0 mr-0 mr-sm-1 col-12 col-md-2"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="updateSection(item)"
          >
            ثبت
          </b-button>

        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BMedia, BAvatar, BOverlay, BFormTextarea, BFormGroup
} from 'bootstrap-vue'

import {PostCreateRequest} from "@/libs/Api/Post";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {StaticPageGetByTypeRequest, StaticPageUpdateRequest} from "@/libs/Api/StaticPage";
import {AccountGetSliderRequest, AccountSetSliderRequest} from "@/libs/Api/Account";
import Helper from "@/libs/Helper";
import ckEditorMain from "@/views/components/ckEditorMain.vue";

export default {
  name: "aboutUs",
  title: 'ویرایش قوانین و مقررات - پنل ادمین ذهن آرایی',
  data() {
    return {
      pageData: null,
      base64ImageSrc: null,
      pic: null,
      showLoading: false,
    }
  },
  async created() {
    await this.getData();
  },
  methods: {
    async getData() {
      let _this = this;
      _this.showLoading = true;

      let type = 3;

      let staticPageGetByTypeRequest = new StaticPageGetByTypeRequest(_this);
      staticPageGetByTypeRequest.setType(type);
      await staticPageGetByTypeRequest.fetch(function (content) {
        _this.showLoading = false;
        _this.pageData = content;
      }, function (error) {
        _this.showLoading = false;
        console.log(error)
      })
    },
    setEditorContent(content) {
      this.pageData[0].content = content;
      console.log(content);
    },
    async updateSection(param) {
      let _this = this;

      _this.showLoading = true;

      let staticPageUpdateRequest = new StaticPageUpdateRequest(_this);
      staticPageUpdateRequest.setParams(param);
      await staticPageUpdateRequest.fetch(function (content) {
        _this.showLoading = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `عملیات موفق`,
            icon: 'CheckIcon',
            variant: 'success',
            text: `عملیات انجام شد.`,
          },
        })
        _this.getData();
      }, function (error) {
        _this.showLoading = false;
        console.log(error)
      })
    },
  },
  components: {
    ckEditorMain,
    BCard,
    BRow,
    BCol,
    BButton,
    BMedia,
    BAvatar,
    BOverlay,
    BFormTextarea,
    BFormGroup
  },
}
</script>

<style scoped>

</style>